import React from 'react';
import { CONFIG } from '../config/global';

const HeroSection: React.FC = () => {
  const handleCTAClick = () => {
    window.open(CONFIG.calendlyLink, '_blank');
  };

  return (
    <section className="min-h-screen flex items-center justify-center bg-background px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-text mb-6 leading-tight">
          {CONFIG.company.tagline}
        </h1>
        <p className="text-xl sm:text-2xl text-text/80 mb-12 max-w-3xl mx-auto leading-relaxed">
          Scale up your personal trainer business with Emerik
        </p>
        <button
          onClick={handleCTAClick}
          className="bg-primary hover:bg-primary/90 text-white font-semibold py-4 px-8 rounded-full text-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
        >
          Get Started Today
        </button>
      </div>
    </section>
  );
};

export default HeroSection;
